export default "https://assets-v2.scaler.com/packs/files/desktop-confetti.f8fbcb.lottie";